import computeClassName from '../../../../../../../utils/computeClassName';
import { usePartnerSearchContext } from '../../../../../ContextProvider/Partner/Search';
import FormTabs from './FormTabs';
import TabbedForms from './TabbedForms';
import AppliedSearchAndSortCriteria from './AppliedSearchAndSortCriteria';
import {useScreenContext} from "../../../../../ContextProvider/Screen";
//import CCAnnouncementBanner from '../../../../../../libs/CiscoCore/Announcement/Banner';

const constants = Object.freeze({
  CLASSNAME_BASE: '-mx-4 2xs:-mx-0 bg-cc-primary shadow-cc-lg 2xs:mb-2 z-10'
});

export default function SearchForms({className}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { areFiltersShown } = usePartnerSearchContext();
  const { isScreen2XSAndUp } = useScreenContext();
  return (
    <header className={computedClassName}>
      <FormTabs/>
      {
        isScreen2XSAndUp &&
        <div className="p-6 2xs:px-10 sm:px-cc-15 2xs:py-7 sm:py-10 bg-cc-primary">
          <TabbedForms className="mb-5"/>
          <AppliedSearchAndSortCriteria/>
        </div>
      }
      {
        !isScreen2XSAndUp && areFiltersShown() &&
        <div className="p-6 2xs:px-10 sm:px-cc-15 2xs:py-7 sm:py-10 bg-cc-primary">
          <TabbedForms className="mb-5"/>
          <AppliedSearchAndSortCriteria/>
        </div>
      }
    </header>
  );
}
